module.exports = __webpack_public_path__ + "bc49cd6172f1069ff5484ecdac3d6553.fbx";